import React from 'react';
import styled from 'styled-components';
import SelectList from '../select/SelectList';
import { KeywordItemType } from '@/api/type/commonTypes';
import { fonts } from '@/theme/fonts';
import { useTranslation } from 'react-i18next';

interface CommonSearchProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClickSearch: () => void;
  onClickReset: () => void;
  options: KeywordItemType[];
  onSelect: (item: KeywordItemType) => void;
  selectedOption: KeywordItemType;
}
const CommonSearch = ({
  value,
  onChange,
  onClickSearch,
  onClickReset,
  options,
  onSelect,
  selectedOption,
}: CommonSearchProps) => {
  const { t } = useTranslation();
  return (
    <Container>
      <SelectList
        options={options}
        onSelect={onSelect}
        selectedOption={selectedOption}
      />
      <InputWrap>
        <Input
          value={value}
          onChange={onChange}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onClickSearch();
            }
          }}
          placeholder={
            selectedOption.keyword === 'REGISTERED_AT'
              ? t('common.searchPlaceholder')
              : ''
          }
        />
        <SearchBtn onClick={onClickSearch}>{t('common.search')}</SearchBtn>
      </InputWrap>
      <RefreshButton onClick={onClickReset}>{t('common.reset')}</RefreshButton>
    </Container>
  );
};

export default CommonSearch;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
`;

const InputWrap = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  height: 40px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #ffffff;
`;

const Input = styled.input`
  flex: 1;
  padding: 0 12px;
  border: none;
  outline: none;
  font-size: 14px;
`;

const SearchBtn = styled.button`
  height: 100%;
  padding: 0 20px;
  border-radius: 6px;
  background: #2563eb;
  color: #ffffff;
  font-size: 14px;
  font-weight: ${fonts.weight.semiBold};
`;

const RefreshButton = styled.button`
  height: 40px;
  padding: 0 16px;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #d1d5db;
  color: #374151;
  font-size: 14px;
`;
